// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wI-z","isFullWidth":"xI-z","landingPageVideo":"yI-z","play":"zI-z","iframeVideo":"AI-z","playHidden":"BI-z","fullwidth":"CI-z"};